import { Skeleton } from '@material-ui/lab';
import { ColorDynamic, Column, Columns, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import styled from 'styled-components';

const TooltipSkeletonBar = styled(Skeleton)`
  background-color: ${ColorDynamic.Silver500};

  &::after {
    background: linear-gradient(
      90deg,
      transparent,
      ${ColorDynamic.White},
      transparent
    );
  }
`;

export function LoadInspectionSyncTooltipSkeleton() {
  return (
    <Box
      padding="xsmall"
      minWidth="240px"
      maxWidth="450px"
      role="status"
      aria-label="Loading inspection sync details"
    >
      <Stack space="xxsmall">
        <Columns space="xsmall">
          <Column width="2/3">
            <TooltipSkeletonBar variant="text" width="100%" height={20} />
          </Column>
          <Column width="1/3">
            <TooltipSkeletonBar variant="text" width="100%" height={20} />
          </Column>
        </Columns>
        <TooltipSkeletonBar variant="rect" width="100%" height={3} />
        <Columns space="xsmall">
          <Column width="1/5">
            <TooltipSkeletonBar variant="text" width="100%" height={20} />
          </Column>
          <Column width="1/5">
            <TooltipSkeletonBar variant="text" width="100%" height={20} />
          </Column>
          <Column width="3/5">
            <TooltipSkeletonBar variant="text" width="80%" height={20} />
          </Column>
        </Columns>
      </Stack>
    </Box>
  );
}
